import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface KpiCardProps {
  label: string
  value: ReactNode
  sub?: ReactNode
  icon?: ReactNode
  delta?: { value: string; up?: boolean }
  color?: 'default' | 'emerald' | 'amber' | 'rose' | 'navy'
  className?: string
}

const colorStyles: Record<NonNullable<KpiCardProps['color']>, string> = {
  default: 'text-navy-700',
  emerald: 'text-emerald-600',
  amber: 'text-amber-600',
  rose: 'text-rose-600',
  navy: 'text-navy-700',
}

export function KpiCard({
  label,
  value,
  sub,
  icon,
  delta,
  color = 'default',
  className,
}: KpiCardProps) {
  return (
    <div className={cn('mini-stat', className)}>
      <div className="mini-stat-label">
        {icon && <span className="text-slate-400">{icon}</span>}
        {label}
      </div>
      <div className="flex items-baseline justify-between mt-1.5">
        <div className={cn('number-display text-2xl', colorStyles[color])}>{value}</div>
        {delta && (
          <div
            className={cn(
              'text-[10px] font-medium',
              delta.up ? 'text-emerald-600' : 'text-rose-600'
            )}
          >
            {delta.up ? '↑' : '↓'} {delta.value}
          </div>
        )}
      </div>
      {sub && <div className="text-[11px] text-slate-500 mt-1">{sub}</div>}
    </div>
  )
}
